<template>
  <div class="row">
    <div class="col-12">
      <q-form ref="editForm2">
        <c-card title="사진추가" class="cardClassDetailForm">
          <template slot="card-detail">
            <div class="col-12">
              <c-upload 
                :attachInfo="attachInfo1"
                label="원거리"
                :editable="editable&&!disabled">
              </c-upload>
            </div>
            <div class="col-12">
              <c-upload 
                :attachInfo="attachInfo2"
                label="근거리"
                :editable="editable&&!disabled">
              </c-upload>
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'near-relation-picture',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        count: 0,
        updateBtnProps: {
          data: {
            title: '사고',
            flag: false,
          },
          flagCondition: false,
          btnEditable: false
        }
      }),
    },
    tabParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        accidentStatusCd: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      attachInfo1: {
        isSubmit: '',
        taskClassCd: 'PROCESS_FIRST_PICTURE',
        taskKey: '',
      },
      attachInfo2: {
        isSubmit: '',
        taskClassCd: 'PROCESS_SECOND_PICTURE',
        taskKey: '',
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
    'tabParam.iimAccidentId'() {
      this.setTaskKey();
    },
  },
  computed: {
    disabled() {
      return (this.tabParam.accidentStatusCd === 'ISPC000005' 
          || this.tabParam.approvalStatusCd === 'ASC0000001')
        && !this.popupParam.updateBtnProps.data.flag
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.editable = this.$route.meta.editable;
      this.setTaskKey();
    },
    setTaskKey() {
      let taskKey = this.tabParam && this.tabParam.iimAccidentId ? this.tabParam.iimAccidentId : '';
      this.attachInfo1.taskKey = taskKey
      this.attachInfo2.taskKey = taskKey
    }
  }
};
</script>
